import type { I18nFn } from '#/i18n/types/I18nFn';

type Props = {
  i18n: I18nFn;
  pageIndex: number;
  hitsPerPage: number;
  nbHits: number;
};

export function getResultsDescription({
  i18n,
  pageIndex,
  hitsPerPage,
  nbHits,
}: Props) {
  return i18n('%(first)s-%(last)s of %(total)s', {
    first: (pageIndex * hitsPerPage + 1).toLocaleString(),
    last: Math.min((pageIndex + 1) * hitsPerPage, nbHits).toLocaleString(),
    total: nbHits.toLocaleString(),
  });
}
